import React from 'react';
import logo from '../assets/logo.png';

const PageLoader = () => {
  return (
    <div className="page-loader" role="status" aria-label="Loading">
      <div className="page-loader-inner">
        <img src={logo} alt="Apertscribe" className="page-loader-logo" />
        <div className="page-loader-ring" aria-hidden="true" />
      </div>
    </div>
  );
};

export default PageLoader;
